/*
 * Copyright (C) Fraunhofer IESE 2021-2024 - Pedram (Majid) Jokar, Mher Ter-Tovmasyan,
 * Bestin John, Steffen Hupp, Anna Kleiner, Rafael Aranda Lopez King, Emily Calvet, Philipp Ewen,
 * Matthias Gerbershagen, Milad Chatrangoon, Stefan Schweitzer
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import { CreateOrganizationButton } from "pages/organizations";
import { FC } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { APP_NAME } from "settings";

type CreateNewOrganizationProps = {
  onCreate: () => void;
};

export const CreateNewOrganization: FC<CreateNewOrganizationProps> = ({
  onCreate,
}) => {
  const { t } = useTranslation();

  return (
    <Modal.Body className="px-5 pb-4">
      <Row>
        <Col className="text-center mb-4 lead description">
          {t("chooseOrganizationPage.create.description")}
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="text-center mt-4 lead description">
            {t("chooseOrganizationPage.create.createDescription", {
              appName: APP_NAME,
            })}
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="text-center mt-5" xs={12}>
          <CreateOrganizationButton variant="primary" onClick={onCreate} />
        </Col>
      </Row>
    </Modal.Body>
  );
};
